module.exports = __webpack_public_path__ + "static/posts-a290b53f43548ea7a5f474853aa76186.png";